import { ITopic } from './Topic'
import { IScormCourse } from './ScormCourse'
import { IElement } from '../front-end/src/pages/topic-detail-page/types/IElement'

// TODO migrate these to all caps in the db
export enum TopicVersionTypeEnum {
  SinglePage = 's',
  MultiPage = 'm',
  SCORM = 'scorm',
  VIDEO_ASSESSMENT_INDIVIDUAL = 'VIDEO_ASSESSMENT_INDIVIDUAL',
  VIDEO_ASSESSMENT_GROUP = 'VIDEO_ASSESSMENT_GROUP',
  VIDEO_ASSESSMENT_Q_AND_A = 'VIDEO_ASSESSMENT_Q_AND_A',
  VIDEO_ASSESSMENT_INTERACTIVE = 'VIDEO_ASSESSMENT_INTERACTIVE'
}

export interface ITopicVersion {
  duration: number
  id: number
  status: string
  created_at: string
  allow_retry: boolean
  title: string
  minor_version: number
  major_version: number
  number_quizzes: number
  pass_mark: number
  summary?: string | null
  topic_type: TopicVersionTypeEnum
  updated_at: Date
  topic_id: number
  topic?: ITopic
  scormCourse?: IScormCourse
  elements?: IElement[]
  publishedElements?: IElement[]
  readDurationMins?: number
  edit_token?: string
}

export enum ResourceVersionsOverviewOrderColumn {
  version = 'version_concat',
  createdAt = 'created_at',
  publishedBy = 'published_by_username',
  avgRating = 'average_rating',
  viewsCount = 'views_count',
  lastViewedAt = 'last_viewed_at'
}
